/**
 *
 * JobCardActionsMenu
 *
 */
import * as React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components/macro';
import { IconButton, Menu, MenuItem } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisVertical } from "@fortawesome/pro-solid-svg-icons";
import { useJobsSlice } from "app/pages/JobsPage/slice";
import { Api } from "../../../../store/api";
import { useOutletContext } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useRecentJobsPanel } from 'app/components/RecentJobsSidepanel/hooks/useRecentJobsPanel';
import { ConfirmationDialog } from 'app/components/ConfirmationDialog';

interface Props { job: any, setIsShareModalOpen, setCopyLinkButtonText, handleMakePublic, handleMakePrivate, onAfterDeleteJob?: (removedJobId: string) => void }

export function JobCardActionsMenu(props: Props) {
  const [userProfile] = useOutletContext<any>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = React.useState<boolean>(false);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const { actions } = useJobsSlice();
  const { deleteJob, selectedTab } = useRecentJobsPanel();

  // for admins to override the preview
  const canSetStylePresetPreviewAudioFile = userProfile?.is_admin || false

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDeleteClick = (e) => {
    e.stopPropagation();
    setIsDeleteConfirmOpen(true);
    handleClose();
  };

  const handleDeleteJob = async () => {
    try {
      await Api.deleteJob(props.job.uuid)
      // Update redux state jobs list
      dispatch(actions.deleteJob(props.job.uuid));
      if(selectedTab) deleteJob(props.job.uuid);
      if(props.onAfterDeleteJob) props.onAfterDeleteJob(props.job.uuid);
      setIsDeleteConfirmOpen(false);
    } catch (error) {
      console.error('Error deleting job:', error);
      toast.error('Failed to delete job. This job type cannot be deleted.');
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleOverrideStylePresetPreview = async () => {
    console.log("overring style preview")
    const samplerStyleRefPresetId = props.job.func_kwargs["sampler_style_ref_id"] || props.job.func_kwargs["sampler_style_ref2_id"]
    // TODO share similar logic from JobCard in how to traverse dwon to audio file preview url, changed to get id
    let audio_file_outputs = props.job.audio_file_outputs
    const audioFileId = audio_file_outputs.length > 0 && audio_file_outputs[0].audio_file?.id
    try {
      await Api.updateSamplerStyleRefPreset(samplerStyleRefPresetId, { override_preview_audio_file_id: audioFileId })
      toast.success("Style Preview Updated")
    } catch (err) {
      toast.error("Failed to update Preview")
    }
    handleClose();
  }

  return (
    <Div>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size={"small"}
        style={{ color: '#F5E1FFBD' }}
      >
        <FontAwesomeIcon icon={faEllipsisVertical} />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {props.job.status === 'COMPLETED' && !props.job?.is_public && (
          <MenuItem onClick={(e) => {
            props.setIsShareModalOpen(true);
            props.setCopyLinkButtonText("COPY");
            props.handleMakePublic();
            dispatch(actions.updateJobIsPublicLocally({ uuid: props.job.uuid, is_public: true }));
          }}>
            Share
          </MenuItem>
        )}

        {props.job.status === 'COMPLETED' && props.job?.is_public && (
          <MenuItem onClick={(e) => {
            props.handleMakePrivate();
            dispatch(actions.updateJobIsPublicLocally({ uuid: props.job.uuid, is_public: false }));
          }}>
            Make Private
          </MenuItem>
        )}

        {/*<MenuItem onClick={handleClose}>Share</MenuItem>*/}
        {/*<MenuItem onClick={handleClose}>Save To Library</MenuItem>*/}
        {canSetStylePresetPreviewAudioFile && (
          <MenuItem onClick={handleOverrideStylePresetPreview}>Override Style Preview</MenuItem>
        )}

        <MenuItem onClick={handleDeleteClick}>Delete</MenuItem>
      </Menu>

      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onCancel={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleDeleteJob}
        confirmButtonText="Delete"
        title="Are you sure?"
      >
        <DeleteDialogText>This will permanently delete your output and cannot be undone. You'll need to regenerate this output if you want it again.</DeleteDialogText>
      </ConfirmationDialog>
    </Div>
  );
}

const DeleteDialogText = styled.p`
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 400;
  text-align: center;
`;

const Div = styled.div`
  display: flex;
  flex-direction: row;
  
  flex-shrink: 0;
`;
